import axios from "axios";
import {
  ADD_ORG_BALANCE,
  EDIT_ORG,
  FILE,
  GET_WHITE_LABEL_DOMAIN,
  ORG_DITAILS,
  ORG_ENABLE_DESABLE,
  POST_CREATE_WHITE_LABEL_DOMAIN,
  PUT_EDIT_WHITE_LABEL_DOMAIN,
} from "../../constant/API constant";

export const getWhiteLabelDomain = () => {
  return axios.get(
    `${process.env.REACT_APP_WHITE_LABEL_API_URL}${GET_WHITE_LABEL_DOMAIN}`
  );
};

export const Post_create_White_Label_Domain = (formData) => {
  return axios.post(
    `${process.env.REACT_APP_WHITE_LABEL_API_URL}${POST_CREATE_WHITE_LABEL_DOMAIN}`,
    formData
  );
};

export const Put_edit_White_Label_Domain = (formData) => {
  return axios.put(
    `${process.env.REACT_APP_WHITE_LABEL_API_URL}${PUT_EDIT_WHITE_LABEL_DOMAIN}`,
    formData
  );
};

export const Org_Details = (orgId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${ORG_DITAILS}`, {
    headers: { Authorization: jwt_token },
    params: { orgId },
  });
};

export const Edit_Org = (formData, orgId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(`${process.env.REACT_APP_API_URL}${EDIT_ORG}`, formData, {
    headers: { Authorization: jwt_token },
    params: { orgId },
  });
};

export const Add_Org_Balance = (formData) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${ADD_ORG_BALANCE}`,
    formData,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

export const Org_Enable_Desable = (formData, orgId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${ORG_ENABLE_DESABLE}`,
    formData,
    {
      headers: { Authorization: jwt_token },
      params: { orgId },
    }
  );
};

export const FILE_API = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${FILE}`, formData);
};
